<template>
  <v-card color="grey lighten-3">
    <v-layout wrap align-center class="body-2">
      <v-flex class="pa-2">
        <span class="success--text">Online</span>
        <span class="ml-2">{{ countAgentStatus.online }}</span>
      </v-flex>
      <v-divider vertical></v-divider>
      <v-flex class="pa-2">
        <span class="error--text">Offline</span>
        <span class="ml-2">{{ countAgentStatus.offline }}</span>
      </v-flex>
    </v-layout>
  </v-card>
</template>

<script>
export default {
  computed: {
    countAgentStatus() {
      let status = {
        online: 0,
        offline: 0
      }

      const tempCountAgentStatus = this.$store.state.ttbCountAgentStatus
      if (tempCountAgentStatus) {
        status.online = tempCountAgentStatus.online
        status.offline = tempCountAgentStatus.offline
      }
      return status
    }
  },
  mounted() {
    if (!this.$store.state.ttbCountAgentStatus) {
      this.$store.dispatch('loadAgentStatusOnlineOffline')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/features/ttb/DashboardNonvoice/Agents/WorkTime/StatusOverview.vue